/**
 * Firebase Configuration Module
 * 
 * This module re-exports Firebase services from the main firebase/index.js file
 * to maintain compatibility with existing imports while ensuring only one
 * Firebase app initialization occurs.
 */

// Import and re-export all Firebase services from the main module
import { 
  auth as firebaseAuth, 
  firestore as firebaseFirestore, 
  storage as firebaseStorage, 
  rtdb as firebaseRtdb, 
  analytics as firebaseAnalytics, 
  perf as firebasePerf 
} from './index'

// Re-export with standard names
export const auth = firebaseAuth
export const firestore = firebaseFirestore  
export const storage = firebaseStorage
export const rtdb = firebaseRtdb
export const analytics = firebaseAnalytics
export const performance = firebasePerf

// Legacy exports for backward compatibility
export const db = firebaseFirestore

// Utility functions for safe Firebase usage
export const isFirebaseAvailable = () => {
  return !!(firebaseAuth && firebaseFirestore)
}

export const requireFirebase = (serviceName = 'Firebase') => {
  if (!isFirebaseAvailable()) {
    throw new Error(`${serviceName} is not available. Firebase initialization failed.`)
  }
}